<template>
    <div class="meeting-item products-entry" :class="{ 'toggled': expanded }">
        <header class="meeting-item__header py-lg">
            <div class="products-entry__title h4">
                <h4 class="h4">{{ title }}</h4>
            </div>
            <div class="card-accordion__toggle meeting-item__icon expand" @click="expanded = !expanded">
                <svg class="icon expand__plus-outline">
                    <use xlink:href="#plus-outline" />
                </svg>
                <svg class="icon expand__plus-solid">
                    <use xlink:href="#plus-solid" />
                </svg>
                <svg class="icon expand__minus-outline">
                    <use xlink:href="#minus-outline" />
                </svg>
                <svg class="icon expand__minus-solid">
                    <use xlink:href="#minus-solid" />
                </svg>
            </div>
        </header>

        <div v-if="expanded" class="products-entry__toggled-content">
            <div v-if="documents.length" class="mb-xl">
                <h3 class="h6 mb-md text--grey-light uppercase">Downloads</h3>
                <ul class="meeting-item__list">
                    <li v-for="(document, index) in documents" :key="index" class="meeting-item__list-item py-md">
                        <span class="small semi">{{ document.title }}</span>
                        <a class="h6 text--orange" :href="document.url" target="_blank" rel="noopener">Download
                            <svg class="ml-xs icon text--orange"><use xlink:href="#download" /></svg>
                        </a>
                    </li>
                </ul>
            </div>

            <div v-if="links.length" class="mb-xl">
                <h3 class="h6 mb-md text--grey-light uppercase">Links</h3>
                <ul class="meeting-item__list">
                    <li v-for="(link, index) in links" :key="index" class="meeting-item__list-item py-md">
                        <span class="small semi">{{ link.title }}</span>
                        <a class="h6 text--orange" :href="link.url" target="_blank" rel="noopener">View
                            <svg class="ml-xs icon text--orange"><use xlink:href="#arrow-right" /></svg>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MeetingItem",
        props: {
            title: {
                type: String,
                    default() {
                    return ''
                },
            },
            documents: {
                type: Array,
                    default() {
                    return []
                },
            },
            links: {
                type: Array,
                default() {
                    return []
                },
            },
        },
        data() {
            return {
                expanded: false
            };
        }
    }
</script>
<style lang="scss">

    .meeting-item {
        border-top: 1px solid #dddddd;
    }

    .meeting-item__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
    }

    .meeting-item__icon {
       .icon {
           font-size: 30px;
       }
    }

    .meeting-item__list-item {
        border-top: 1px solid #dddddd;
        display: flex;
        justify-content: space-between;

        a {
            flex-shrink: 0;
            margin-left: 15px;
        }
    }
</style>
